<template>
  <div class="storemnt">
    <!-- 路由的容器 -->
    <router-view :key="key"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    key () {
      if (!this.$route.query.NoRefresh) {
        var key = Math.random()
        this.$commonfun.localStorage.setitem('routekey', key)
        return this.$route.path + key
      } else {
        return this.$route.path + this.$commonfun.localStorage.getitem('routekey')
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .storemnt{
    height: calc( 100% - 121px );
    min-width: 1120px;
    background: #F2F2F2;
    padding-bottom: 20px;
    /*padding-right: 20px;*/
    transition: padding-left .28s;
  }
</style>
